import ProductCollectionContainer from './ProductCollection';
import { Component } from '../../types/schema';
import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';
// eslint-disable-next-line import/no-named-default
import { default as styles } from '../../scss/pages/_plp.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

type ProductComponentCollectionProps = Pick<Component, 'type' | 'collections'>;

const ProductComponentCollection = ({
  type, collections: [collection],
}: ProductComponentCollectionProps) => (
    <>
        <div id={collection?.slug ?? undefined} className={withCssModulesClassNamesHandler('product-component-collection', 'plp', type)}>
        {
          collection ? (
            <ProductCollectionContainer
              collection={{
                ...collection,
                activeCollectionLayout: null,
                gridContainerClassNames: [],
              }}
            />
          ) : null
        }
      </div>
    </>
);

export default ProductComponentCollection;
